import { Base } from 'src/api/Base'
import { omit } from 'lodash-es'

export class CustomGroupsAPI extends Base {
  static get entity() {
    return 'custom-groups'
  }

  static async get(_, { customCancelEvent } = {}) {
    const params = {
      customGroupId: this.datepicker.customGroupId,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
      customCancelEvent,
    }).get(`/${this.entity}/get`, {
      params,
    })
    return data
  }

  static async getKpis() {
    const { data } = await this.request().get(`/${this.entity}/kpis`)
    return data
  }

  static async getDefaultKpis() {
    const { data } = await this.request().get(`/${this.entity}/default-kpis`)
    return data
  }

  static async getReports() {
    const params = {
      customGroupId: this.datepicker.customGroupId,
    }
    const { data } = await this.request().get(`/${this.entity}/reports`, { params })
    return data
  }

  static async addReport({ isGlobal, name, dealerships, dealerGroupIds, metrics, orderBy }) {
    const params = {
      customGroupId: this.datepicker.customGroupId,
    }

    const body = {
      isGlobal,
      name,
      dealerships,
      metrics,
      orderBy,
      dealerGroupIds,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/add-report`, body, { params })

    return data.report
  }

  static async updateReport({
    isGlobal,
    name,
    dealerships,
    dealerGroupIds,
    metrics,
    reportId,
    orderBy,
  }) {
    const params = {
      customGroupId: this.datepicker.customGroupId,
      reportId,
    }

    const body = {
      isGlobal,
      name,
      dealerships,
      metrics,
      orderBy,
      dealerGroupIds,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update-report`, body, { params })

    return data.report
  }

  static async getData({ kpi, period, dealerGroupIds, dealerships }, { customCancelEvent } = {}) {
    const { customGroupId, year, quarter, month, view } = this.datepicker
    const params = {
      customGroupId,
      year,
      quarter,
      month,
      view,
      kpi,
      dealerGroupIds,
      dealerships,
    }

    switch (period) {
      case 'previous':
        params.period = 'previous'
        break

      case 'lastYear':
        params.period = view === 'year' ? 'previous' : 'lastYear'
        break
    }

    const { data } = await this.request({ customCancelEvent }).get(`/${this.entity}/data`, {
      params,
    })

    return data
  }

  static async export({
    customGroupId = 1,
    kpis,
    format,
    dealerGroupIds,
    dealerships,
    orderBy,
    options,
  } = {}) {
    const params = {
      ...omit(this.datepicker, ['dealerGroupId', 'dealerShipId']),
      customGroupId,
      kpis: kpis.join(','),
      dealerGroupIds,
      dealerships,
      format,
      orderBy,
      options,
    }

    const { data } = await this.request().get(`/${this.entity}/export-data`, {
      params,
    })
    return data
  }
}
